import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map } from 'rxjs/operators';
import {
  isPointCloudOutput,
  isVideoOutput,
} from '../../../../../cross-team-shared/misc-utils/output-utils';
import { Output as AnnotationOutput } from '../../../../../team-apis/otterdam/outputs/output';
import { SplitViewService } from '../split-view/split-view.service';

@Component({
  selector: 'h3-split-view-output-label',
  templateUrl: './split-view-output-label.component.html',
  styleUrl: './split-view-output-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SplitViewOutputLabelComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input() outputs: AnnotationOutput[] = [];
  @Input({ required: true }) outputName!: string;
  @Input({ required: true }) isSelected!: boolean;
  @Input() canSwitchOutput = false;
  @HostBinding('class.selected') selected!: boolean;

  private readonly splitViewService = inject(SplitViewService);

  outputIndex = 0;

  ngOnInit() {
    this.bindToInstance('selected', this.getInput$('isSelected'));
    this.bindToInstance(
      'outputIndex',
      this.getInput$('outputName').pipe(
        map((outputName) =>
          this.outputs.findIndex((output) => output.name === outputName),
        ),
      ),
    );
  }

  shouldDisplayArrows() {
    return this.outputs.filter(isVideoOutput).length > 1;
  }

  switchOutputTo(direction: 'left' | 'right') {
    const output = this.outputs[this.getSwitchToOutputIndex(direction)];
    this.splitViewService.changeSplitViewOutput(
      output.name,
      'split_view_arrows',
    );
  }

  private getSwitchToOutputIndex(direction: 'left' | 'right') {
    return direction === 'left'
      ? this.getPreviousOutputIndex()
      : this.getNextOutputIndex();
  }

  private getPreviousOutputIndex() {
    let newIndex = this.outputs.findLastIndex(
      (output, index) =>
        !isPointCloudOutput(output) && index < this.outputIndex,
    );

    if (newIndex >= 0) {
      return newIndex;
    }

    newIndex = this.outputs.findLastIndex(
      (output, index) =>
        !isPointCloudOutput(output) && index > this.outputIndex,
    );
    return newIndex >= 0 ? newIndex : this.outputIndex;
  }

  private getNextOutputIndex() {
    let newIndex = this.outputs.findIndex(
      (output, index) =>
        !isPointCloudOutput(output) && index > this.outputIndex,
    );

    if (newIndex >= 0) {
      return newIndex;
    }

    newIndex = this.outputs.findIndex(
      (output, index) =>
        !isPointCloudOutput(output) && index < this.outputIndex,
    );
    return newIndex >= 0 ? newIndex : this.outputIndex;
  }
}
